"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.match.js");
var _vuePropertyDecorator = require("vue-property-decorator");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _url = require("@zz-eg/common-lib/dist/url");
var _utils = require("../utils");
var _dec, _dec2, _class, _class2, _descriptor, _descriptor2;
var _native;
if (!_utils.isServer) {
  _native = require('@zz-common/native-adapter').default; // eslint-disable-line global-require
}

var useUA = /zzdevice\/(.*?)\s/.test(_utils.UA);
var FixTop = (_dec = (0, _vuePropertyDecorator.Prop)({
  type: String,
  default: '#fff'
}), _dec2 = (0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: true
}), (0, _vuePropertyDecorator.Component)(_class = (_class2 = /*#__PURE__*/function (_Vue) {
  (0, _inheritsLoose2.default)(FixTop, _Vue);
  function FixTop() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Vue.call.apply(_Vue, [this].concat(args)) || this;
    // 顶部任务栏颜色
    (0, _initializerDefineProperty2.default)(_this, "headerTaskbarBG", _descriptor, (0, _assertThisInitialized2.default)(_this));
    // 是否隐藏头部
    (0, _initializerDefineProperty2.default)(_this, "needHideHead", _descriptor2, (0, _assertThisInitialized2.default)(_this));
    // 顶部任务栏高度
    _this.htmlPaddingTop = 0;
    // 头部吸顶高度
    _this.headerHeight = 0;
    // 是否在客户端内（包括转转和切克）
    _this.isApp = false;
    // 是否在转转内
    _this.isZZ = false;
    // 是否在切克内
    _this.isCheck = false;
    // 是否在采货侠内
    _this.isCHX = false;
    // 是否在找靓机内
    _this.isZLJ = false;
    // 是否是苹果手机
    _this.isIOS = _utils.isIOS;
    return _this;
  }
  var _proto = FixTop.prototype;
  _proto.created = function created() {
    if (_utils.isServer) return;
    if (!_utils.isServer && this.$expandAdapter) _native = this.$expandAdapter;
    this.isZZ = _native.in('zz');
    this.isCheck = _native.in('checkapp');
    this.isCHX = _native.in('zzhunter');
    this.isZLJ = _native.in('zlj');
    this.isApp = this.isZZ || this.isCheck || this.isCHX || this.isZLJ;
    this.hideHeadCheck();
  }

  // 隐藏头部
  // 不处理情况：
  // 1.不在在客户端内;
  // 2.在客户端内传参不需要隐藏头部;
  // 3.在安卓内且needHideHead参数不为2和3
  ;
  _proto.hideHeadCheck = function hideHeadCheck() {
    var _this2 = this;
    console.log('---hideHeadCheck');
    if (!this.isApp || this.isApp && !this.needHideHead) return;
    _native.wrap('setHeaderVisible')({
      visible: '0'
    }, this.getPageTopHeight(function (res) {
      var code = res.code,
        height = res.height;
      if (code === 0 || !height) return;
      _this2.htmlPaddingTop = useUA || _this2.isIOS ? +height : _this2.adpaterPx(+height);

      // 执行 page-base-box 的回调，剥离无关逻辑
      _this2.headerHeight = _this2.headerHeight + _this2.htmlPaddingTop;
    }));
  }

  // 计算像素的相对值
  ;
  _proto.adpaterPx = function adpaterPx(px) {
    // 获取页面根元素 font-size
    var rem = +(document.documentElement.style.fontSize || '37.5px').slice(0, -2);
    return px / 75 * rem;
  }

  // 获得页面顶部刘海屏占据高度
  ;
  _proto.getPageTopHeight = function getPageTopHeight(callback) {
    var queryNeedHideHead = (0, _url.getQueryParam)('needHideHead') || '';
    console.log('queryNeedHideHead', queryNeedHideHead);
    if (!this.isIOS && !['2', '3'].includes(queryNeedHideHead)) {
      return callback({
        code: 0
      });
    }
    var currentV = (0, _url.getQueryParam)('zzv') || _jsCookie.default.get('v') || '8.0.0';
    var isZZ6Plus = this.isZZ && (0, _utils.compareVersion)(currentV, '6.10.0') > -1;
    if (useUA) {
      try {
        var supportTransparent = 0;
        var statusbarHeight = 0;
        var arr = _utils.UA.match(/zzdevice\/(.*?)\s/)[1].split('_');
        supportTransparent = arr[0];
        statusbarHeight = arr[1] / arr[2];
        supportTransparent ? callback({
          code: 1,
          height: +statusbarHeight
        }) : callback({
          code: 0
        });
      } catch (error) {
        callback({
          code: 0
        });
      }
    } else if (isZZ6Plus || this.isCHX) {
      try {
        _native.wrap('isStatusBarSupportTransparent')(function (res) {
          console.log('是否支持挖空屏', res.support === '1');
          if (res.support === '1') {
            _native.wrap('getStatusBarHeight')(function (res) {
              callback({
                code: 1,
                height: +res.height
              });
            });
          } else {
            callback({
              code: 0
            });
          }
        });
      } catch (e) {
        console.log('getStatusBarHeight Error:', e);
      }
    } else if (this.isZLJ) {
      _native.wrap('getSystemExtraInfo')({
        success: function success(res) {
          callback({
            code: 1,
            height: +res.stateHeight
          });
        }
      });
    } else {
      console.log('getStatusBarHeight Error: 非客户端版本，或客户端版本太低');
      callback({
        code: 0
      });
    }
  };
  return FixTop;
}(_vuePropertyDecorator.Vue), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "headerTaskbarBG", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "needHideHead", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
exports.default = FixTop;